/*
 * @Author: zyy
 * @Date: 2022-09-21 14:56:05
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-16 17:26:01
 * @Description: default
 */


import shopRequests from "../shopRequest";
import Qs from 'qs'
export default {
    // 订单列表
    list(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_order/index', {
            params,

        })
    },
    detail(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_order/detail', {
            params,
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    // 快递公司
    courierCompany(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_express/select', {
            params,
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    // 手动发货
    deliverByInput(params) {
        return shopRequests.post('shop/admin_api_order/deliverByInput', params)
    },
    afterSaleInfo(id) {
        return shopRequests.get(`shop/order_aftersale/detail`, {
            params: {
                id
            }
        })
    }

}